import React, { useState, useEffect, useCallback } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import tick from '../../../../assets/img/tick.png';
import rejected from '../../../../assets/img/rejected.png';
import returned from '../../../../assets/img/returned.png';
import { showModal } from '../../../redux/error/ErrorAction';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, POST } from '../../../services/rest.service';
import { getTotalShareVal, extractUserDocs, displayAmount } from '../../../helpers/utils';
import ShowClearingForwardingDocs from '../../global/ShowClearingForwardingDocs';
import { showDocumentModal } from '../../../redux/user/UserActions';
import Payments from '../../global/Payments';
import { PAYMENT_RELATED_TO_SUBSCRIPTION } from '../../../helpers/constants';
import DirectorShareholderForm from '../../global/DirectorShareholderForm';
import AddPortsModal from '../../global/PortOfOperations/AddPortsModal';
import { useVerifyme } from '../../../helpers/customHooks';
import VerificationModalSteps from './Steps';
import VerficationModalForm from './Form';

const VerificationModal = ({ verficationModal, toggleVerificationModal, container }) => {
  // console.log(verficationModal);
  const serviceData = useSelector((state) => state.enumData);
  // console.log(serviceData);
  const { user } = useSelector((state) => state.user);
  // console.log(user);
  const regPaymentDone = user?.registration_fee_paid !== 0;

  const registrationAmount =
    user.type === 'clearing_agent'
      ? parseInt(serviceData.settings.general.clearing_registration_fee)
      : parseInt(serviceData.settings.general.forwarding_registration_fee);

  const [step, setStep] = useState(1);
  const [formValues, setFormValues] = useState({});
  const [shareValues, setShareValues] = useState({});
  const [images, setImages] = useState({});
  const [paystatus, setPaystatus] = useState(false);
  const dispatch = useDispatch();
  const [isEditMode, setIsEditMode] = useState(false);
  const [right, setRight] = useState(false);
  //select box depende register year file
  const [type, setType] = useState('director');
  const [details, setDetails] = useState({});
  const [id, setId] = useState('');
  const [isEdit, setisEdit] = useState(false);
  const [totalShareVal, setTotalShareVal] = useState(0);
  const [lastCheckedStatus, setLastCheckedStatus] = useState(null);

  const showDoc = (docc) => dispatch(showDocumentModal(docc));

  // initialize verifyme hook
  const {
    isDocVerified,
    showOTPField,
    verifyMeData,
    setIsDocVerified,
    setShowOTPField,
    setVerifyMeData,

    storeVerifyMeData,
    sendMsgOtp,
    verifyDocument,
    verifyUserOtp,
  } = useVerifyme(dispatch);

  const [isRefresh, setIsRefresh] = useState(false);

  //user details
  const getUserDetails = (stayOnCurrentStep = false, updateFormValues = true) => {
    dispatch(showLoading());
    if (user.uuid) {
      const userReq = GET(`/users/getDetails/${user.uuid}`);
      const portsReq = POST('/ports/getAgentPort', { agent_uuid: user.uuid });

      Promise.all([userReq, portsReq])
        .then(([{ data }, { data: portsData }]) => {
          // console.log('>>>>> data', data);
          const ports = portsData?.ports || [];

          // calculate totalShareholder percentage
          const totalShares = getTotalShareVal(data);
          setTotalShareVal(totalShares);
          if (!isEmpty(data.documents)) {
            const item = extractUserDocs(data);
            setDetails({
              ...data,
              documents: item,
              port_of_operations: ports,
            });
            setIsEditMode(true);
            setImages({
              ...images,
              incorporation_certificate: item.incorporation_certificate,
              memorandum_article_association: item.memorandum_article_association,
              corporate_address_proof: item.corporate_address_proof,
              registration_certificate: item.registration_certificate,
              registration_application_status: item.registration_application_status,
              ctc_cac_1_1: item.ctc_cac_1_1,
              cac_2: item.cac_2,
              cac_7: item.cac_7,
            });
            const modifiedItem = {
              ...item,
              port_of_operation: item.port_of_operation || '',
            };
            // console.log(modifiedItem);
            if (!stayOnCurrentStep || updateFormValues) {
              setFormValues(modifiedItem);
            }
          } else {
            setDetails({
              ...data,
              port_of_operations: ports,
            });
            setIsEditMode(false);
          }
          // ... rest of the status logic remains the same
          // (copying the rest of the logic as it was in the file)
          // Step initialization based on verification status
          // Exclude rc_no from documents check as it's filled at signup
          const isIdentityVerified = data?.user?.identity_verified === 1;

          // Update last checked status
          setLastCheckedStatus(data?.user?.identity_verified);

          // All requirements check
          const docsObj = extractUserDocs(data);
          const hasRegCert = !!docsObj.registration_certificate;
          const hasRcNo = !!docsObj.rc_no;
          const hasRegCertNo = !!docsObj.registration_certificate_no;
          const hasDirector = data.directors && data.directors.length > 0;
          const hasPort = ports && ports.length > 0;

          const allRequirementsMet =
            user.type === 'clearing_agent'
              ? hasRegCert && hasRcNo && hasRegCertNo && hasDirector && hasPort
              : hasRcNo && hasDirector;

          const regFeePaid = data?.user?.registration_fee_paid !== 0;

          if (stayOnCurrentStep && !isIdentityVerified) {
            // Stay put
          } else if (!allRequirementsMet) {
            setStep(1);
          } else if (isIdentityVerified) {
            // Identity verified by admin - show appropriate step
            if (regFeePaid && registrationAmount !== 0) {
              setStep(4);
            } else if (regFeePaid || registrationAmount === 0) {
              setStep(3);
            } else {
              setStep(2);
            }
          } else {
            // Documents uploaded but not verified yet (0 or 2) - show finish/waiting screen
            if (registrationAmount === 0) {
              setStep(3);
            } else {
              setStep(4);
            }
          }

          dispatch(hideLoading());
        })
        .catch((err) => {
          dispatch(showModal(err.message));
          dispatch(hideLoading());
        });
    }
  };

  // Poll for verification status updates every 10 seconds when modal is open
  useEffect(() => {
    if (!verficationModal) return;

    const pollInterval = setInterval(() => {
      if (user.uuid) {
        GET(`/users/getDetails/${user.uuid}`)
          .then(({ data }) => {
            const currentStatus = data?.user?.identity_verified;

            // Check if status changed from not-verified to verified
            if (lastCheckedStatus !== 1 && currentStatus === 1) {
              // Force re-fetch all details if now verified
              getUserDetails();
              // Auto-close modal after 2 seconds when verified
              setTimeout(() => {
                toggleVerificationModal();
                dispatch(showModal('Your documents have been verified successfully!', true));
              }, 2000);
            }
          })
          .catch((err) => console.error('Polling error:', err));
      }
    }, 10000); // Check every 10 seconds

    return () => clearInterval(pollInterval);
  }, [verficationModal, user.uuid, lastCheckedStatus]);

  //useEffect
  useEffect(() => {
    if (verficationModal) {
      // isRefresh true means we closed a sidebar, so we stay on step and DON'T update form values from server
      getUserDetails(isRefresh, !isRefresh);
      if (isRefresh) setIsRefresh(false);
    }
  }, [verficationModal]);

  // next payment menthod choose step
  const nextPay = () => {
    setStep(2);
  };
  const nextPay2 = () => {
    setStep(3);
  };

  //right sidebar open function
  const rightOpen = (type, currentValues = null) => {
    if (currentValues) {
      setFormValues(currentValues);
    }
    setRight(true);
    setType(type);
    toggleVerificationModal();
  };
  // right siderbar close function
  const rightClose = () => {
    setRight(false);
    setIsRefresh(true);
    toggleVerificationModal();
    setShareValues({});
    setId('');
    setisEdit(false);

    setIsDocVerified(false);
    setShowOTPField(false);
    setVerifyMeData({});
  };

  const editRight = (id, type, currentValues = null) => {
    if (currentValues) {
      setFormValues(currentValues);
    }
    swal({
      title: `Edit ${type}?`,
      text: `Do you want to edit ${type}?`,
      icon: 'warning',
      buttons: ['Cancel', 'Yes'],
    }).then((result) => {
      dispatch(showLoading());
      if (result) {
        setisEdit(true);
        let filt = {};
        if (type === 'shareholder') {
          filt = details.shareholders.filter((obj) => obj.uuid == id);
        } else {
          filt = details.directors.filter((obj) => obj.uuid == id);
        }
        setType(type);
        setId(id);
        setShareValues(filt[0]);

        // >> Verifyme Verification related
        // if (checkVeifymeVerified(filt[0])) {
        //   setIsDocVerified(true);
        // }
        if (filt[0]?.phone_verified_at) {
          setIsDocVerified(true);
        }

        dispatch(hideLoading());
        rightOpen(type);
      }
    });

    // console.log(filt[0]);
  };

  const deleteRight = (id, type, currentValues = null) => {
    if (currentValues) {
      setFormValues(currentValues);
    }
    swal({
      title: `Delete ${type}?`,
      text: `Do you want to delete ${type}?`,
      icon: 'warning',
      buttons: ['Cancel', 'Yes'],
    }).then((result) => {
      dispatch(showLoading());
      if (result) {
        if (type === 'shareholder') {
          POST(`/users/deleteShareholder`, { id: id })
            .then(({ data }) => {
              dispatch(showModal(`${type} delete successfully`, true));
              getUserDetails(true);
              setIsRefresh(true);
              dispatch(hideLoading());
            })
            .catch((err) => {
              dispatch(hideLoading());
            });
        } else {
          POST(`/users/deleteDirector`, { id: id })
            .then(({ data }) => {
              dispatch(showModal(`${type} delete successfully`, true));
              getUserDetails(true);
              setIsRefresh(true);
              dispatch(hideLoading());
            })
            .catch((err) => {
              dispatch(hideLoading());
            });
        }
      }
    });
  };

  const nextStep = useCallback(() => setStep((s) => s + 1), []);
  const prevStep = useCallback(() => setStep((s) => s - 1), []);

  const handlepaymentSuccess = useCallback(() => {
    nextStep(); // change step
    setPaystatus(true);
    getUserDetails();
    // setStep(4);
  }, [nextStep]);

  const handleBackFromPaymentMethod = useCallback(
    (paymentStep = 1) => {
      if (paymentStep === 1) {
        prevStep();
      }
    },
    [prevStep],
  );

  const regAmountNotAvailable = registrationAmount === 0;

  // Modal cannot be closed manually - only auto-closes when admin verifies
  const handleToggleModal = useCallback(() => {
    swal({
      title: 'Wait for Admin Approval',
      text: 'Your document verification is pending. Please wait for admin approval.',
      icon: 'info',
      button: 'OK',
    });
  }, []);

  return (
    <>
      <Modal
        isOpen={verficationModal}
        toggle={handleToggleModal}
        container={container}
        className="modal-xl"
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-header">
          <button type="button" className="close" onClick={toggleVerificationModal}>
            &times;
          </button>
        </div>
        <ModalBody>
          <>
            <div id="tabblock1" className="tabcontent full-modal-width clearing-varification-mt">
              <h3 className="head-line-pay">
                {user.type == 'clearing_agent'
                  ? `Clearing Agent Documents Upload ${regAmountNotAvailable ? '' : 'and Payment'}`
                  : `Transporter Documents Upload ${regAmountNotAvailable ? '' : 'and Payment'}`}
              </h3>

              <div className="bodycont">
                <div className="">
                  <div className={`row tab-complian ${regAmountNotAvailable ? 'no-payment' : ''}`}>
                    <VerificationModalSteps
                      step={step}
                      isEditMode={isEditMode}
                      registrationAmount={registrationAmount}
                      user={user}
                      paystatus={paystatus}
                    />
                    {step === 1 && (
                      <VerficationModalForm
                        formValues={formValues}
                        details={details}
                        isEditMode={isEditMode}
                        totalShareVal={totalShareVal}
                        user={user}
                        rightOpen={rightOpen}
                        editRight={editRight}
                        images={images}
                        showDoc={showDoc}
                        deleteRight={deleteRight}
                        handleNext={() => nextPay(2)}
                        onDocumentUpdateSuccess={() => {
                          // After successful upload, go to step 2 (view documents)
                          nextPay();
                          setIsEditMode(true);
                          getUserDetails(true, true);
                        }}
                      />
                    )}

                    {step === 2 && (
                      <div className="col-sm-9">
                        <div className="head-p-model">
                          <h3 className="head-line">My Profile</h3>

                          <div className="profilecont">
                            <div className="mx-2">
                              {formValues && (
                                <ShowClearingForwardingDocs
                                  showDoc={showDoc}
                                  images={images}
                                  formValues={formValues}
                                  userType={user.type}
                                  details={details}
                                  shareholdersColClassName="col-12"
                                  showShareHolderSelect={true}
                                />
                              )}
                            </div>
                          </div>

                          <div className="buttonsec">
                            <a className=" edit-model-button submitbut" onClick={() => setStep(1)}>
                              Edit
                            </a>
                            {(registrationAmount !== 0 &&
                              details?.user?.registration_fee_paid === 1) ||
                            paystatus ? (
                              <a
                                href="#"
                                className="next-model-button submitbut"
                                onClick={() => setStep(4)}
                              >
                                Next
                              </a>
                            ) : (
                              <a
                                href="#"
                                className="next-model-button submitbut"
                                onClick={() => nextPay2()}
                              >
                                Next
                              </a>
                            )}
                          </div>
                          <div className="clearfix"></div>
                        </div>
                      </div>
                    )}
                    {registrationAmount !== 0 && step === 3 && (
                      <div className="col-sm-9">
                        <div className="head-p-model">
                          <div className="profilecont">
                            <Payments
                              paymentAmount={registrationAmount}
                              paymentRelatedTo={PAYMENT_RELATED_TO_SUBSCRIPTION}
                              onPaymentSuccess={handlepaymentSuccess}
                              handleBackFromPaymentMethod={handleBackFromPaymentMethod}
                              nextButtonClassName="next-model-button submitbut mt-5"
                              backButtonClassName="edit-model-button submitbut mt-5"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {((regAmountNotAvailable && step === 3) ||
                      (!regAmountNotAvailable && step === 4)) && (
                      <div className="col-sm-9">
                        <div className="head-p-model">
                          <div className="profilecont">
                            <div className="payment-info px-0">
                              <div className="finish p-0">
                                {details?.user?.identity_verified === 2 ? (
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                    <h5 style={{ marginBottom: '0px' }}>Verification Returned</h5>
                                    <div style={{ margin: '0 auto', marginTop: '-25px' }}>
                                      <img src={returned} alt="Returned" style={{ width: '320px', height: 'auto' }} />
                                    </div>
                                    <p style={{ marginTop: '5px', marginBottom: '20px' }}>
                                      Your documents verification is unsuccessful. Please
                                      contact us if you have any questions. Thank you.
                                    </p>
                                    <div className="d-flex" style={{ justifyContent: 'space-between', width: '100%', marginTop: '20px', padding: '0 10px' }}>
                                      <a
                                        href="https://goagent.com.ng/contact-us"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="submitbut m-0"
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '47%', textDecoration: 'none', height: '48px', fontSize: '16px', fontWeight: 'bold' }}
                                      >
                                        Contact Us
                                      </a>
                                      <a
                                        href="#"
                                        className="next-model-button submitbut m-0"
                                        onClick={() => setStep(2)}
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '47%', height: '48px', fontSize: '16px', fontWeight: 'bold' }}
                                      >
                                        View Documents
                                      </a>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <p>
                                      Your documents have been successfully submitted, and are currently being reviewed. Thank you.
                                    </p>
                                    <div>
                                      <img src={tick} alt="" />
                                    </div>
                                    {registrationAmount !== 0 && regPaymentDone && (
                                      <>
                                        <h5>Payment Successful</h5>
                                        <p>
                                          Your payment of {displayAmount(registrationAmount)} for
                                          annual subscription was successful.
                                        </p>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>

                          {details?.user?.identity_verified !== 2 && (
                            <div className="buttonsec" style={{ display: 'flex', justifyContent: 'center' }}>
                              <a
                                href="#"
                                className="next-model-button submitbut"
                                onClick={() => setStep(2)}
                              >
                                View Documents
                              </a>
                            </div>
                          )}
                          <div className="clearfix"></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        </ModalBody>
      </Modal>
      {right && (type === 'director' || type === 'shareholder') ? (
        <DirectorShareholderForm
          isEdit={isEdit}
          toggle={rightClose}
          type={type}
          shareValues={shareValues}
          onSubmit={async (response) => {
            setShareValues({});
            setRight(false);
            setId('');
            setisEdit(false);

            // this condition is for saving the BVN/NIN verifyme data to our db
            if (!isEmpty(verifyMeData)) {
              let directorOrShareHolderId = '';
              if (type === 'director') {
                directorOrShareHolderId = response?.data?.director?.uuid;
              } else {
                directorOrShareHolderId = response?.data?.shareholder?.uuid;
              }
              let vmId = isEdit ? id : directorOrShareHolderId;
              await storeVerifyMeData(vmId, type);
            }

            getUserDetails(true, false);
            setIsRefresh(true);

            // reset verifyme related states
            setIsDocVerified(false);
            setShowOTPField(false);
            setVerifyMeData({});
            toggleVerificationModal();
          }}
          id={id}
          isDocVerified={isDocVerified}
          verifyMeData={verifyMeData}
          setIsDocVerified={setIsDocVerified}
          showDoc={showDoc}
          verifyDocument={verifyDocument}
          showOTPField={showOTPField}
          verifyUserOtp={verifyUserOtp}
          sendMsgOtp={sendMsgOtp}
        />
      ) : type === 'port' ? (
        <AddPortsModal
          isOpen={right}
          toggle={rightClose}
          agentPorts={details.port_of_operations || []}
          onPortAddSuccess={() => {
            getUserDetails(true, false);
            setIsRefresh(true);
            rightClose();
          }}
        />
      ) : null}
    </>
  );
};

export default VerificationModal;
